export class FeedXMLFilters {
  status: string;
  day: string;
  start: Date;
  end: Date;
  size? : number;
  page? : number;
}
